import { IPicture, ICategory } from "../../models";
import {
  IonCard,
  IonCardTitle,
  IonCardSubtitle,
  IonIcon,
  IonText,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonChip,
  IonLabel,
} from "@ionic/react";
import { ellipse, trash, removeCircle, addCircle } from "ionicons/icons";
import { connect } from "react-redux";
import { AppState } from "../main.reducer";
import { CHANGE_RESERVE } from "./cart.actions";
import { SELECT_PICTURE } from "../Pictures/pictures.actions";
import { SELECT_CATEGORY } from "../Menu/menu.actions";
import { Price } from "../../components/Price/Price";
import { DiscountBadge } from "../../components/DiscountBadge/DicsountBadge";
import { IconCategory } from "../Pictures/PictureCard";

type OwnProps = {
  pic: IPicture;
  isPopup?: boolean;
};

const mapStateToProps = (state: AppState, props: OwnProps) => ({
  reserve: state.cart.reserve,
  categories: state.menu.categories as ICategory[],
  darkMode: state.common.darkMode,
});

const mapDispatchToProps = (dispatch: (action: any) => any) => ({
  selectPicture: (picture: IPicture) =>
    dispatch({ type: SELECT_PICTURE, picture }),
  selectCategory: (category: ICategory) =>
    dispatch({ type: SELECT_CATEGORY, category }),
  changeReserve: (
    reserve: { [pictureId: number]: number },
    pictureId: number,
    quantity: number
  ) => {
    const reserveState = { ...reserve, [pictureId]: quantity };
    localStorage.setItem("bpb.reserve", JSON.stringify(reserveState));
    dispatch({ type: CHANGE_RESERVE, pictureId, quantity });
  },
});

type AllProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  OwnProps;

const ReserveItem = (props: AllProps) => {
  const { pic, reserve } = props;

  const categoryName = (id: number) => {
    const category = props.categories.find((c) => c.id === id);
    return category ? category.name : "";
  };

  const removeFromReserve = (id: number) => {
    if (props.reserve[pic.id] > 1) {
      props.changeReserve(reserve, id, props.reserve[id] - 1 || 0);
    }
  };

  return (
    <IonCard style={{ margin: "3px" }}>
      <picture>
        <source
          media="(min-width:650px)"
          srcSet={`assets/pics/${pic.code}.jpg`}
        />
        <img
          src={`assets/pics/320/${pic.code}.jpg`}
          alt={pic.fileName}
          onClick={() => props.selectPicture(pic)}
        />
      </picture>
      <DiscountBadge price={pic.price} priceNoDiscount={pic.priceNoDiscount} />

      <IonCardTitle
        className="ion-text-center f20xs"
        style={{ padding: "5px 0" }}
      >
        {pic.title}
      </IonCardTitle>

      <IonCardContent style={{ padding: 5 }}>
        <IonGrid>
          <IonRow>
            <IonCol size="8">
              <IonText>
                <IonIcon
                  icon={ellipse}
                  style={{
                    paddingRight: 5,
                    color: pic.status
                      ? "var(--ion-color-success-shade)"
                      : "var(--ion-color-danger-shade)",
                  }}
                />
                <IonText className="f15">
                  {pic.status ? "Na stanju" : "Trenutno nema na stanju"}
                </IonText>
              </IonText>
            </IonCol>
            <IonCol size="4" className="ion-text-right">
              <Price price={pic.price} priceNoDiscount={pic.priceNoDiscount} />
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonCardSubtitle>
          <IonChip>
            <IconCategory category={pic.category} />
            <IonLabel>{categoryName(pic.category)}</IonLabel>
          </IonChip>
        </IonCardSubtitle>

        <IonGrid>
          <IonRow>
            {/* <IonCol size="7">
                            {pic.sizeX && pic.sizeY && <IonText>{`Dimenzije: ${pic.sizeX}cm x ${pic.sizeY}cm`}</IonText>}
                        </IonCol> */}
            <IonCol size="12" className="ion-text-right">
              <IonText>{`Šifra: ${pic.code}`}</IonText>
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonGrid>
          <IonRow>
            <IonCol className="ion-text-center">Količina</IonCol>
          </IonRow>
          <IonRow>
            <IonCol className="ion-text-right">
              <IonIcon
                icon={removeCircle}
                size="large"
                color={
                  props.reserve[pic.id] === 1
                    ? "var(--ion-color-light)"
                    : "primary"
                }
                onClick={() => removeFromReserve(pic.id)}
                className={props.reserve[pic.id] === 1 ? "" : "cursorP"}
              />
            </IonCol>
            <IonCol className="ion-text-center f18 b" style={{ paddingTop: 5 }}>
              <IonLabel>{props.reserve[pic.id]}</IonLabel>
            </IonCol>
            <IonCol className="ion-text-left">
              <IonIcon
                icon={addCircle}
                size="large"
                color="primary"
                onClick={() =>
                  props.changeReserve(reserve, pic.id, reserve[pic.id] + 1 || 1)
                }
                className="cursorP"
              />
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonGrid>
          <IonRow>
            <IonCol size="12" offset="0">
              <IonButton
                color="danger"
                expand="block"
                fill="outline"
                onClick={() => props.changeReserve(reserve, pic.id, 0)}
              >
                <IonIcon icon={trash} size="medium" slot="start" />
                Odjavi
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </IonCard>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ReserveItem);
